import { render, staticRenderFns } from "./AuthAboutus.vue?vue&type=template&id=2f0169d3&scoped=true&"
import script from "./AuthAboutus.vue?vue&type=script&lang=js&"
export * from "./AuthAboutus.vue?vue&type=script&lang=js&"
import style0 from "./AuthAboutus.vue?vue&type=style&index=0&id=2f0169d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0169d3",
  null
  
)

export default component.exports